import React, { Component } from "react"
import { connect } from "react-redux"

// components
import Navbar from "../../components/layout/DashboardNavbar"
import MainSection from "../../components/layout/MainSection"
import ScrollableContentCard, { Padding } from "../../components/layout/ScrollableContentCard"
import Footer from "../../components/Footer"
import { COLOR } from "../../modules/constants"


// mui
import Typography from "@mui/material/Typography"
import Box from "@mui/material/Box"
// import Divider from "@mui/material/Divider"
import { withStyles } from "@mui/styles"

const styles = () => ({
  root: {
  },
  title: {
    color: COLOR.BRAND.STD,
    fontFamily: "comfortaa",
    fontSize: "22px",
    fontWeight: "bold",
    marginTop: "15px",
    marginBottom: "15px",
  },
  heading: {
    fontSize: "18px",
    fontWeight: "bold",
    marginTop: "10px",
    marginBottom: "15px",
  },
  paragraph: {
    fontSize: "16px",
    marginBottom: "15px",
  }
})

class AboutNumerable extends Component {
  render() {
    const { classes, portrait, the350club, urlSource } = this.props

    const hrefAbout = `https://www.numerable.io/?utm_source=${urlSource}&utm_medium=numapp&utm_campaign=about`
    const hrefContact = `https://www.numerable.io/contact/?utm_source=${urlSource}&utm_medium=numapp&utm_campaign=aboutcontact`

    return (
      <React.Fragment>
        <Navbar
          title="About"
          backLink
          portrait={portrait}
        />

        <MainSection portrait={true}>
          <ScrollableContentCard limitedWidth>
            <Padding>
              <Typography component="div">
                <Box className={classes.title}>
                  About the Numerable Board Intelligence Platform
                </Box>

                <Box className={classes.paragraph}>
                  Numerable is a cutting edge online software system that gives fast, convenient access to valuable information on UK companies, directors and their connections - with a particular focus on public companies.
                </Box>

                <Box className={classes.paragraph}>
                  It shows boards as interactive tables or diagrams and gives direct links to Annual Reports, websites and Companies House. You can browse, search, filter and sort to quickly find what you need.
                </Box>

                <Box className={classes.paragraph}>
                  Numerable collects up-to-date information from Companies House. For FTSE and AIM listed companies, it combines this with additional data from the regulated information that they release.
                </Box>

                <Box className={classes.paragraph}>
                  Numerable is developed and owned by <a href={hrefAbout} rel="noopener noreferrer" target="_blank" >Numerable Software Ltd</a>, based in Bristol.
                </Box>

                {the350club &&
                  <Box className={classes.paragraph}>
                    We are pleased to partner with The 350 Club to offer access to Numerable free of charge to The 350 Club members. A version is also available for enterprise use, with advanced features and information.
                  </Box>
                }

                <Box className={classes.heading}>
                  Feedback
                </Box>
                <Box className={classes.paragraph}>
                  We'd love your feedback to help us improve. You can get in touch from our <a href={hrefContact} rel="noopener noreferrer" target="_blank" >contact form</a>.
                </Box>

                <Box className={classes.heading}>
                  More information
                </Box>

                <Box className={classes.paragraph}>
                  Visit our website at <a href={hrefAbout} rel="noopener noreferrer" target="_blank" >numerable.io</a>
                </Box>

              </Typography>

            </Padding>
          </ScrollableContentCard>
        </MainSection >

        <Footer urlSource={this.props.urlSource} />
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({ common, user }) => {
  return {
    the350club: common.the350club,
    urlSource: common.urlSource,
    portrait: user.portrait,
  }
}

// @ts-ignore
export default connect(mapStateToProps)(withStyles(styles)(AboutNumerable));


